import defaultSettings from '@/settings';
var title = defaultSettings.title || 'Vue Admin Template';
export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return "".concat(pageTitle, " - ").concat(title);
  }
  return "".concat(title);
}